import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, XCircle, Clock, Loader, ArrowRightLeft } from 'lucide-react';
import { api } from '../lib/api';

interface ImportJob {
  job_id: string;
  status: string;
  file_name: string;
  target_product: string;
  target_entity: string;
  total: number;
  succeeded: number;
  failed: number;
}

export default function MigrationsPage() {
  const [jobs, setJobs] = useState<ImportJob[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // In a full implementation, this would list all jobs from a dedicated endpoint.
    // For now, show a placeholder.
    setLoading(false);
  }, []);

  const statusIcon = (status: string) => {
    switch (status) {
      case 'completed': return <CheckCircle size={16} color="#10b981" />;
      case 'failed': return <XCircle size={16} color="#ef4444" />;
      case 'running': return <Loader size={16} color="#f97316" />;
      default: return <Clock size={16} color="#6b7280" />;
    }
  };

  return (
    <div>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 700, margin: '0 0 1.5rem', color: '#111827' }}>Migrations & Import Jobs</h2>

      {loading ? (
        <p style={{ color: '#6b7280' }}>Loading...</p>
      ) : jobs.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', backgroundColor: '#fff', borderRadius: '0.5rem', border: '1px solid #e5e7eb' }}>
          <ArrowRightLeft size={48} color="#d1d5db" style={{ marginBottom: '1rem' }} />
          <p style={{ color: '#6b7280', marginBottom: '1rem' }}>No migration or import jobs yet.</p>
          <Link to="/import" style={{ color: '#f97316', textDecoration: 'underline' }}>Start a CSV import</Link>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {jobs.map(job => (
            <Link key={job.job_id} to={`/migrations/${job.job_id}`} style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '1rem', backgroundColor: '#fff', borderRadius: '0.5rem', border: '1px solid #e5e7eb', textDecoration: 'none', color: '#111827' }}>
              {statusIcon(job.status)}
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: '0.9375rem' }}>{job.file_name}</div>
                <div style={{ fontSize: '0.8rem', color: '#6b7280' }}>
                  {job.target_product} / {job.target_entity} &middot; {job.total.toLocaleString()} rows
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: '0.875rem', fontWeight: 600, color: '#10b981' }}>{job.succeeded} ok</div>
                {job.failed > 0 && <div style={{ fontSize: '0.75rem', color: '#ef4444' }}>{job.failed} failed</div>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
